export const hotelBedSizeType = {
  single: "シングル",
  double: "ダブル",
  queen: "クイーン",
  king: "キング",
};
